export default {
  recipeFinished: 'Receptura nie jest już wykonywana. Nie można zapisać Twoich zmian.',
  loadStarted: 'Podczas edycji uruchomiono wsad. Wartości zadane pieca można zmieniać tylko wtedy, gdy żaden wsad nie jest realizowany.',
  otherRecipeRunning: 'Obecnie realizowany jest inny wsad lub inna receptura. Nie można zapisać Twoich zmian.',
  passedStepNotSaved: 'Zmiany w {step} nie zostaną zapisane, ponieważ ten krok został już zakończony.',
};
